import { Box, Button } from "@mui/material";
import * as labels from "config.labels";
import React from "react";
import * as staticDataHooks from "store/hooks/staticDataHooks";

const LiteralEditActions = ({ onSave, onCancel, saveDisabled = false }) => {
  const translateLabels = staticDataHooks.useTranslator("uiLabels");
  return (
    <Box sx={{ display: "flex", gap: 1, py: 0.5 }}>
      <Button
        size={"small"}
        variant={"contained"}
        onClick={onSave}
        disabled={saveDisabled}
        fullWidth
      >
        {translateLabels(labels.EXPRESSION_EDITOR_LITERAL_SAVE, {
          default: "Save",
        })}
      </Button>
      <Button
        size={"small"}
        variant={"contained"}
        color={"secondary"}
        onClick={onCancel}
        fullWidth
      >
        {translateLabels(labels.EXPRESSION_EDITOR_LITERAL_CANCEL, {
          default: "Cancel",
        })}
      </Button>
    </Box>
  );
};

export default LiteralEditActions;
